Ext.ns('mx.app.widget');

mx.app.widget.GeoRegionWindow = Ext.extend(mx.app.widget.WindowForm, {
    labels: {
        check: 'Check',
        ok: 'OK',
        clear: 'Clear',
        polygonValidationError: 'This polyline is not valid polygon',
        polygonValidationErrorTitle: 'Error',
        polygonCheckingMsg: 'Checking polygon integrity',
    },
    urls: {
        checkPolygon: mx.PATH + 'api/helper/checkPolyline',
    },
    initialPolyline: [],
    getMapComponent: function() {
        return this.form.components.mapComponent;
    },
    buttons: {
        checkButton: null,
    },
    showInvalidPolygonMessage: function() {
        Ext.MessageBox.alert(this.labels.polygonValidationErrorTitle, this.labels.polygonValidationError);
    },
    addButtons: function() {
        this.addEvents('ok', 'check', 'clear');

        this.buttons.checkButton = this.addButton({
            name: 'check_window_btn',
            text: this.labels.check,
            handler: function(btn, e) {
                if (this.fireEvent('check', btn, e) !== false) {
                    // validate polyline on map (via request to server)
                    var mapComponent = this.getMapComponent();
                    if (!mapComponent.noMap()) {
                        var polyline = mapComponent.getPolyline();
                        if (polyline.points.length > 2) {
                            if (polyline.intersectsItself()) {
                                this.showInvalidPolygonMessage();
                            } else {
                                polyline.close();
                            }
                        }
                    }
                }
            },
            disabled: true,
            scope: this,
        });

        this.addButton({
            name: 'clear_window_btn',
            text: this.labels.clear,
            handler: function(btn, e) {
                if (this.fireEvent('clear', btn, e) !== false) {
                    this.getMapComponent().clearPolyline();
                    this.buttons.checkButton.setDisabled(true);
                }
            },
            scope: this,
        });

        this.addButton({
            name: 'ok_window_btn',
            text: this.labels.ok,
            handler: function(btn, e) {
                var polyline = this.getMapComponent().getPolyline();
                var points = polyline ? (polyline.points ? polyline.points : []) : [];
                if (points.length > 2) {
                    if (polyline.intersectsItself()) {
                        this.showInvalidPolygonMessage();
                    } else {
                        polyline.close();
                        this.fireEvent('ok', {points: points, window: this}, e);
                    }
                } else if (points.length > 0) {
                    this.showInvalidPolygonMessage();
                } else {
                    this.fireEvent('ok', {points: points, window: this}, e);
                }
            },
            scope: this,
        });
    },
    initComponent: function() {
        mx.app.widget.GeoRegionWindow.superclass.initComponent.apply(this, arguments);
        if (this.form) {
            var clickOnMapCallback = function() {
                if (!this.getMapComponent().noMap()) {
                    this.buttons.checkButton.setDisabled(this.getMapComponent().getPolylinePoints().length < 3);
                }
            };
            this.form.addListener('mapclicked', clickOnMapCallback, this);

            var initPolylineOnMapReady = function() {
                var points = mx.Util.Cookies.decodePointsCookie(this.initialPolyline);
                this.getMapComponent().addPolylineFromPoints(points);
            };
            this.form.addListener('mapready', initPolylineOnMapReady, this);
        }
    },
});
